var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 -130 512 612",
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.016,62.969c0,34.797-27.983,62.985-62.517,62.985C28,125.954,0,97.766,0,62.969               C0,28.203,28,0,62.499,0C97.032,0,125.016,28.203,125.016,62.969z M115.874,170.641H10.156V512h105.718V170.641z M284.844,170.641               H183.468V512h101.376c0,0,0-126.609,0-179.188c0-48,22.107-76.563,64.404-76.563c38.875,0,57.563,27.422,57.563,76.563               c0,49.172,0,179.188,0,179.188H512c0,0,0-124.719,0-216.125c0-91.468-51.846-135.641-124.252-135.641               c-72.422,0-102.904,56.407-102.904,56.407V170.641L284.844,170.641z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.0eaeb6cafce3d90414078f1f6f0ac155.svg";
export { ForwardRef as ReactComponent };